// extracted by mini-css-extract-plugin
export var carouselWidget = "StrapiReviewsIOComponent-module--carousel-widget--59284";
export var carouselWidget_frame = "StrapiReviewsIOComponent-module--carousel-widget_frame--a16d7";
export var root = "StrapiReviewsIOComponent-module--root--c3d18";
export var title = "StrapiReviewsIOComponent-module--title--d6fe4";